<template>
<div style="display: flex; flex-direction: column; height: 100vh;">
    <v-app-bar
    outlined
    flat
    color="white"
    height="60px"
    absolute
    fixed
    style="border-bottom: 1px solid #EDEDED !important;"
  >
      <IconTooltipButtonBottom
          icon="mdi-arrow-left"
          tooltip="Zurück zur Liste"
          id="default"
          width="50px"
          large
          @click="$router.go(-1)"
      />
      <v-spacer></v-spacer>
    <v-toolbar-title>{{ checklistTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div>
    </div>
  </v-app-bar>
  <div style="flex: 1 1 auto; overflow-y: auto; margin-top:64px; height:100%;" class="px-12 pt-2">
    <div class="bg-gray px-12 py-12 mx-8 my-8 text-center checklist-callout">
      <h1 class="mb-10">Einführung einer digitalen Technologie im Betrieb</h1>
      <p>Ihr Betrieb hat beschlossen eine neue digitale Technologie einzuführen. Für den Erfolg der neuen digitalen Technologie in Ihrem Betrieb ist es unerlässlich, dass Sie Ihre Beschäftigten durch den Einführungsprozess begleiten. </p>
    </div>
    <div class="px-12 py-4">
      <h2>Wie können Sie dies am besten tun?</h2>
      <p>Sie setzen fünf aufeinander aufbauende Schritte um:</p>
    </div>
  <div class="connected-steps px-12 py-4">
    <div class="container-step">
      <div class="stepText">Zweck bestimmen</div>
      <div class="step numeric">1</div>
      <div class="step-spacer"></div>
    </div>
    <div class="connector"></div>
    <div class="container-step">
      <div class="step-spacer"></div>
      <div class="step numeric">2</div>
      <div class="stepText">Gezielt vorbereiten</div>
    </div>
    <div class="connector"></div>
    <div class="container-step">
      <div class="stepText">Weiter anpassen</div>
      <div class="step numeric">3</div>
      <div class="step-spacer"></div>
    </div>
    <div class="connector"></div>
    <div class="container-step" :class="(skipStep4 === true) ? 'inactive-opacity':''">
      <div class="step-spacer"></div>
      <div class="step numeric">4</div>
      <div class="stepText">Unternehmensweit verbreiten</div>
    </div>
    <div class="connector"></div>
    <div class="container-step">
      <div class="stepText">Routinen neu etablieren</div>
      <div class="step numeric">5</div>
      <div class="step-spacer"></div>
    </div>
  </div>
    <div class="px-12 py-8">
      Soll die Veränderung direkt Unternehmesweit verbreitet werden oder erstmal nur in einer Teilgruppe?
      <v-radio-group v-model="skipStep4" @change="checkStep4State">
        <v-radio
            label="Unternehmensweit"
            :value="true"
        ></v-radio>
        <v-radio
            label="Teilgruppe"
            :value="false"
        ></v-radio>
      </v-radio-group>
    </div>

  <v-btn x-large elevation="0" class="startBtn" color="secondary" rounded
             @click="startChecklist()">Starten</v-btn>
  </div>
</div>
</template>

<script>
import DataTable from '../../components/common/DataTable.vue';
import checklistService from "./checklist-service.js"
import FormDialog from '@/components/common/FormDialog.vue';
import IconTooltipButtonBottom from '@/components/common/IconTooltipButtonBottom.vue';

export default {
  components: { 
    DataTable,
    FormDialog,
    IconTooltipButtonBottom
  },
  name: "ChecklistTitlePage",
  data() {
    return {
      skipStep4:false
    };
  },
  computed:{
    checklistTitle(){
      return this.$route.params.checklistTitle;
    },
    checklistId(){
      return this.$route.params.listId;
    }
  },
  mounted() {
    let ths = document.querySelectorAll('th>span');
    for (let elem of ths) {
      if (elem.innerHTML.length > 18) {
        elem.parentElement.setAttribute("style", "display:flex;");
        elem.setAttribute("style", "display:flex;max-width:4rem;justify-content:center;align-items:center;");
      }
    }
  },
  methods: {
    startChecklist(){
      this.$router.push({name: 'answerList', params: { listId: this.checklistId}, query:{ skipStep4: this.skipStep4}})
    },
  }
};
</script>
<style scoped>
.white{
  color: var(--v-secondary-base) !important;
}

.v-tab--active{
  color:initial;
}

.v-tab--active > .v-chip{
  background-color: var(--v-secondary-base) !important;
  color: #F5F5F5 !important;
}

#tab{
  max-width:unset;
}

#tab.active{
  font-size: 10rem;
}

#chip{
  margin-left: 10px;
}

#datatable{
  position: inherit !important;
}

.badge {
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  font-size: 25px;
  color: #fff;
  text-align: center;
  background-color: var(--v-primary-base);
  margin:auto;
}

.checklist-callout {
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

.checklist-callout p {
  width: 40vw;
  margin: 0 auto;
}

.connected-steps {
  display: flex;
  width: 100%; 
  align-items: center;
}

.step {
  width: 50px;
  height: 50px;
  line-height: 46px;
  font-weight: 600;
  /*border-radius: 50%;*/
  font-size: 25px;
  color: var(--v-primary-base);
  text-align: center;
  position: relative;
  display: block;
}

.step::after {
  content: '';
  position: absolute;
  width: 50px;
  height: 50px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: var(--v-primary-base);
  opacity: .1;
  top: 0;
  left: 0;
}

.connector {
  padding: 0px 10px;
  width:10%;
  height: 2px;
  position: relative;
}

.connector::after {
  position: absolute;
  content: '';
  background: var(--v-primary-base);
  opacity: .1;
  width: 100%;
  height: 4px;
}

.container-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
}

.stepText{
  text-align: center;
  max-width: 120px;
  font-size: 1rem;
  font-weight: bold;
  margin: 15px;
}
.step-spacer {
  height: 50px;
  margin: 15px;
}
.startBtn{
  /*position: fixed;*/
  /*bottom: 5vh;*/
  /*right: calc(50% - 100px);*/
  /*width: 100px;*/
  -webkit-border-radius: 26px;
  -moz-border-radius: 26px;
  border-radius: 26px;
  width: 132px;
  display: block;
  margin: 10px auto 100px auto;
  /*height: 80px !important;*/
}
</style>